export const FETCH_FEEDBKDETAILS_INIT_ACTION = "FETCH_FEEDBKDETAILS_INIT_ACTION"
export const FETCH_FEEDBKDETAILS_SUCCESS_ACTION = FETCH_FEEDBKDETAILS_INIT_ACTION + '_SUCCESS'
export const FETCH_FEEDBKDETAILS_FAIL_ACTION = FETCH_FEEDBKDETAILS_INIT_ACTION + '_ERROR'


export function feedbkList() {
   
    return {
        type: FETCH_FEEDBKDETAILS_INIT_ACTION
    }
}